window.$ = window.jQuery = require('jquery');
window.jQueryBridget = require('jquery-bridget');
require('./bootstrap.js');
window.Flickity = require('flickity');
jQueryBridget( 'flickity', Flickity, $ );
require('./main.js');